<template>
  <div class="entryFormInput">
    <form-select
      v-if="field.inputType === 'select'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      :isdisabled="disabledFlg"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-select>

    <form-radio
      v-else-if="field.inputType === 'radio'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-radio>

    <form-switch
      v-else-if="field.inputType === 'switch'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-switch>

    <form-checkbox
      v-else-if="field.inputType === 'checkbox'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-checkbox>

    <form-birthtime
      v-else-if="field.inputType === 'birthtime'"
      :name="name"
      :unknown-name="field.unknownName"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-birthtime>

    <form-birthday
      v-else-if="field.inputType === 'birthday'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :placeholderYear="field.placeholderYear"
      :placeholderMonth="field.placeholderMonth"
      :placeholderDay="field.placeholderDay"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-birthday>

    <form-textarea
      v-else-if="field.inputType === 'textarea'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :rows="field.rows"
      :placeholder="field.placeholder"
      :validation="{
      required: entryDetailRequired,
      max: 400
    }"
      @input="input"
    >
      <template slot="aside" v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-textarea>

    <form-textarea
      v-else-if="field.inputType === 'textarea_option'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :rows="field.rows"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      @input="input"
    >
      <template slot="aside" v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-textarea>

    <form-password
      v-else-if="field.inputType === 'password'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      @input="input"
      :streng-meter="field.strengMeter"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-password>

    <form-file
      v-else-if="field.inputType === 'file'"
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-file>

    <form-palm-input
      v-else-if="field.inputType === 'palm'"
      :name="name"
      :label="field.label"
      :fields="field.fields"
      :values="field.values"
      :storagePath="field.storagePath"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-palm-input>

    <form-input
      v-else
      :name="name"
      :label="field.label"
      :value="field.value"
      :options="field.options"
      :placeholder="field.placeholder"
      :validation="field.rules || {}"
      @input="input"
    >
      <template v-if="field.aside">
        <p v-html="field.aside" class="u-tx-sub formGroup__subText"></p>
      </template>
    </form-input>
  </div>
</template>

<script>
export default {
  name: "entry-form-input",
  inject: ["$validator"],
  props: {
    name: {
      type: String,
      required: true
    },
    field: {
      type: Object,
      required: true
    },
    isEditMode: Boolean,
    entryDetailRequired: Boolean,
    disabledFlg: Boolean
  },
  created() {
    this.$emit('init')
  },
  methods: {
    input(value) {
      this.$emit("input", value)
      this.$emit("change", value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/EntryFormInput.vue